import { ApiClient } from './client';

export function fetchCampuses(client: ApiClient): Promise<any> {
  return client.get('/ahiapi/campuses');
}

export function fetchCampusData(client: ApiClient, campusId: string): Promise<any> {
  return client.get(`/ahiapi/${campusId}/campus/comfort`);
}

export function fetchCampusEnergy(client: ApiClient, campusId: string): Promise<any> {
  return client.get(`/ahiapi/${campusId}/campus/energy`);
}

export function fetchSolarCampuses(client: ApiClient): Promise<any> {
  return client.get('/ahiapi/trendsSolarCampuses');
}
